(function () {
  'use strict';

  const STORAGE_KEY = 'ccn_compare_list';
  const MAX_CARS = 2;

  function getList() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  }

  function saveList(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function isAdded(handle) {
    return getList().some((c) => c.handle === handle);
  }

  function addCar(handle, title) {
    const list = getList();
    if (list.some((c) => c.handle === handle)) return;
    if (list.length >= MAX_CARS) {
      showToast('Remove one car before adding another.');
      return;
    }
    list.push({ handle, title });
    saveList(list);
    refreshAll();
    fireGA4('add_to_compare', { car_handle: handle, car_title: title });
  }

  function removeCar(handle) {
    const list = getList().filter((c) => c.handle !== handle);
    saveList(list);
    refreshAll();
  }

  function clearList() {
    saveList([]);
    refreshAll();
  }

  // ── Buttons ──────────────────────────────────────────────────────────────

  function refreshButtons() {
    document.querySelectorAll('[data-ccn-compare-btn]').forEach((btn) => {
      const handle = btn.dataset.productHandle;
      const added = isAdded(handle);
      btn.classList.toggle('ccn-compare-btn--added', added);
      // Only set textContent for simple buttons (no inner spans)
      if (!btn.querySelector('span.ccn-pdp-compare-btn__label')) {
        btn.textContent = added ? 'Added ✓' : '+ Compare';
      }
    });
  }

  function handleButtonClick(e) {
    e.preventDefault();
    e.stopPropagation();
    const btn = e.currentTarget;
    const handle = btn.dataset.productHandle;
    const title = btn.dataset.productTitle;
    if (isAdded(handle)) {
      removeCar(handle);
    } else {
      addCar(handle, title);
    }
  }

  function bindButtons() {
    document.querySelectorAll('[data-ccn-compare-btn]').forEach((btn) => {
      btn.removeEventListener('click', handleButtonClick);
      btn.addEventListener('click', handleButtonClick);
    });
  }

  // ── Floating bar ─────────────────────────────────────────────────────────

  function getBar() {
    return document.getElementById('ccn-compare-bar');
  }

  function renderBar() {
    const list = getList();
    const bar = getBar();
    if (!bar) return;

    // Hide entirely on the compare hub/result page — user is already there
    if (window.location.pathname.startsWith('/pages/compare')) {
      bar.classList.remove('ccn-compare-bar--visible');
      return;
    }

    if (list.length === 0) {
      bar.classList.remove('ccn-compare-bar--visible');
      return;
    }

    const car1 = list[0] || null;
    const car2 = list[1] || null;

    const slot = (car) =>
      car
        ? `<div class="ccn-compare-bar__name">
             <span class="ccn-compare-bar__name-text">${car.title}</span>
             <button class="ccn-compare-bar__remove" data-remove-handle="${car.handle}" aria-label="Remove ${car.title}">✕</button>
           </div>`
        : `<div class="ccn-compare-bar__empty">Pick a car…</div>`;

    const compareUrl =
      list.length === MAX_CARS
        ? `/pages/compare?car1=${list[0].handle}&car2=${list[1].handle}`
        : null;

    bar.innerHTML = `
      <div class="ccn-compare-bar__inner">
        <span class="ccn-compare-bar__label">Compare vehicles</span>
        <div class="ccn-compare-bar__slots">
          ${slot(car1)}
          <div class="ccn-compare-bar__vs">VS</div>
          ${slot(car2)}
        </div>
        <div class="ccn-compare-bar__actions">
          ${
            compareUrl
              ? `<a href="${compareUrl}" class="ccn-compare-bar__cta" id="ccn-compare-now">Compare Now →</a>`
              : `<span class="ccn-compare-bar__hint">Pick one more car</span>`
          }
          <button class="ccn-compare-bar__clear" id="ccn-compare-clear">Clear</button>
        </div>
      </div>`;

    bar.classList.add('ccn-compare-bar--visible');

    bar.querySelectorAll('[data-remove-handle]').forEach((btn) => {
      btn.addEventListener('click', () => removeCar(btn.dataset.removeHandle));
    });

    const clearBtn = bar.querySelector('#ccn-compare-clear');
    if (clearBtn) clearBtn.addEventListener('click', clearList);

    const ctaBtn = bar.querySelector('#ccn-compare-now');
    if (ctaBtn) {
      ctaBtn.addEventListener('click', () => {
        fireGA4('comparison_started', {
          car1_handle: list[0].handle,
          car2_handle: list[1].handle,
        });
      });
    }
  }

  // ── Toast ─────────────────────────────────────────────────────────────────

  function showToast(msg) {
    let toast = document.getElementById('ccn-compare-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'ccn-compare-toast';
      toast.className = 'ccn-compare-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('ccn-compare-toast--visible');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(() => toast.classList.remove('ccn-compare-toast--visible'), 3000);
  }

  // ── GA4 ───────────────────────────────────────────────────────────────────

  function fireGA4(eventName, params) {
    if (typeof gtag === 'function') {
      gtag('event', eventName, params);
    }
  }

  // ── Init ──────────────────────────────────────────────────────────────────

  function refreshAll() {
    refreshButtons();
    renderBar();
  }

  function init() {
    // Inject floating bar container if not already in DOM
    if (!document.getElementById('ccn-compare-bar')) {
      const bar = document.createElement('div');
      bar.id = 'ccn-compare-bar';
      bar.className = 'ccn-compare-bar';
      bar.setAttribute('aria-live', 'polite');
      document.body.appendChild(bar);
    }

    bindButtons();
    refreshAll();

    // Re-bind after Shopify section re-renders (theme editor live preview)
    document.addEventListener('shopify:section:load', () => {
      bindButtons();
      refreshAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
